import { connect } from "react-redux";
import { project } from "../../store/selectors/projects.selector";
import {
  communicationPlans,
  communicationPlansLoading,
  communicationPlanStatusLoading,
  communicationPagination,
  getError,
} from "../../store/selectors/communications.selector";
import {
  getCommunicationPlan,
  createCommunicationPlanRequest,
  updateCommunicationPlanRequest,
  deleteCommunicationPlanRequest,
} from "../../store/actions/communications.actions";
import Communication from "./Communication";
const mapDispatchToProps = {
  getCommunicationPlanRequest: getCommunicationPlan,
  createCommunicationPlanRequest,
  updateCommunicationPlanRequest,
  deleteCommunicationPlanRequest,
};

const mapStateToProps = (state) => {
  const allPlans = communicationPlans(state);
  const pageLoading = communicationPlansLoading(state);
  const loading = communicationPlanStatusLoading(state);
  const pDetails = project(state);
  const pagination = communicationPagination(state);
  const error = getError(state);
  return { pDetails, allPlans, loading, pagination, error, pageLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(Communication);
